import { useQuery } from "@tanstack/react-query"
import { useEffect } from "react"
import { LIST_USER_INVITATIONS } from "../../../constants"
import { UserInvitation } from "../../../types"
import { useAuthService } from "../services/useAuthService"

type UseInvitesType = {
  invites: UserInvitation[]
  isLoading: boolean
  error: Error | null
}

const useInvites = (): UseInvitesType => {

  const authService = useAuthService()

  const { data: invites, isLoading, error } = useQuery({
    queryKey: [LIST_USER_INVITATIONS],
    queryFn: async (): Promise<UserInvitation[]> => {
      return authService.getInvites()
    },
    refetchInterval: 20000,
  })

  useEffect(() => {
    if (error) {
      // show error message to the user toast
    }
  }, [error])

  return { invites: invites ?? [], isLoading, error }
}

export default useInvites
